import {useSelector} from "react-redux";
import { Navigate } from "react-router-dom"

export const ProtectedRoutes = (props) => {
    const {token} = useSelector(store => store.login);

    return token !== null ? props.children : <Navigate to="/signin" />
}